import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { marked } from 'marked';
import logo from "./logo.jpg";
function App() {
  const [textA, setTextA] = useState('');
  const [textB, setTextB] = useState('');
  const [result, setResult] = useState('');
  const [copied, setCopied] = useState(false);
  const [isEditable, setIsEditable] = useState(false); // editable state
  const [isSubmitted, setIsSubmitted] = useState(false); // track submission state
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleMakeEditable = () => {
    setIsEditable(true);
  };

  useEffect(() => {
    const fetchDefaultText = async () => {
      try {
        const res = await axios.get('https://backend-nia.caigroup.ai/default-text');
        setTextA(res.data[0]); // Adjust according to actual response structure
      } catch (error) {
        console.error('Error during API call:', error);
      }
    };

    fetchDefaultText();
  }, []);
  const copyToClipboard = () => {
    const el = document.getElementById('transcribedContent');
    const html = el.innerHTML;
    const blob = new Blob([html], { type: 'text/html' });
    const data = [new ClipboardItem({ 'text/html': blob })];
    navigator.clipboard.write(data)
      .then(() => setCopied(true))
      .catch(err => console.error("Failed to copy:", err));
  };

  const handleSubmit = async () => {
    setIsSubmitting(true); // Start submission
    try {
      // Send both texts to the API
      const res = await axios.post('https://backend-nia.caigroup.ai/deepgram-chatgpt', {
        extracted_text: textB,
        user_input: textA,
      });
      setResult(res.data);

      // Update default text on backend
      await axios.post('https://backend-nia.caigroup.ai/update-text', {
        text: textA
      });
      setIsSubmitted(true);
    } catch (error) {
      console.error('Error during API call:', error);
    }
    finally{
      setIsSubmitting(false);
    }
  };
  const handleRefresh = () => {
    window.location.reload(); // Refresh the page
  };
  return (
    <div className="main">
      <header>
        <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white   mb-3">
          <div class="container-fluid">
            <img src={logo} alt="Description" />


            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target=".navbar-collapse" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="navbar-collapse collapse d-sm-inline-flex justify-content-between">
              <ul class="navbar-nav flex-grow-1">
                <li>

                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6">
            <div className="whiteBox whiteBoxPrompt">
              <div className="BoxHeader">
                <div><h3>Prompt</h3></div>
                <div>{!isEditable ? (
                  <button type="button" className="EditBTn" onClick={handleMakeEditable}>
                    Edit
                  </button>
                ) : (
                  'Editing'
                )}</div>
              </div>
              <div>
                <textarea
                  rows="10"
                  cols="80"
                  value={textA}
                  onChange={(e) => setTextA(e.target.value)}
                  disabled={!isEditable}
                  style={{ backgroundColor: isEditable ? 'white' : '#f0f0f0' }}
                />
              </div>

            </div>

          </div>

          <div className="col-md-6">
            <div className="whiteBox">
              <div className="BoxHeader">
                <div><h3>Input Deepgram Response</h3></div>
              </div>
              <div>
                <textarea
                  rows="10"
                  cols="80"
                  value={textB}
                  onChange={(e) => setTextB(e.target.value)}
                />
              </div>
              <div className="buttonGroup">
                <button style={{ marginTop: '20px' }} className="submitBtn" onClick={handleSubmit}  disabled={isSubmitted || isSubmitting}>
                {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
                {/* {isSubmitted && ( */}
                  <button
                    style={{ marginTop: '20px', marginLeft: '10px' }}
                    className="resetBtn"
                    onClick={handleRefresh}
                  >
                    Reset
                  </button>
                {/* )} */}
              </div>

            </div>

          </div>


          <div className="col-md-12">
            <div className="whiteBox mt-4">
              <div className="BoxHeader">
                <div> <h3>API Result:</h3></div>
                <div>

                  {copied && <span style={{ color: 'green', marginTop: '10px' }}>Copied to clipboard!</span>}
                  <button onClick={copyToClipboard} className="copyBtn">📋 Copy</button>
                </div>
              </div>
              {result && (
                <div style={{ marginTop: '0px', whiteSpace: 'pre-wrap' }} className="APIResultBo">



                  <div
                    id="transcribedContent"
                    dangerouslySetInnerHTML={{ __html: marked.parse(Array.isArray(result) ? result.join("\n") : result) }}
                    style={{ border: '1px solid #ccc', padding: '10px', borderRadius: '5px' }}
                  />

                </div>
              )}
            </div>

          </div>

        </div>
      </div>



    </div>
  );
}

export default App;
